export default __webpack_public_path__ + "static/media/(38).3d42b60b.jpg";